import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path, Mask, Rect, G } from "react-native-svg";

const CapsuleIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 36 36",
  path: (
    <>
      <Mask
        id="mask0_1035_9227"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="28"
        height="28"
      >
        <Rect x="4" y="4" width="28" height="28" stroke="none" />
      </Mask>
      <G mask="url(#mask0_1035_9227)">
        <Path
          stroke="none"
          d="M14.0625 28.5C12.2347 28.5 10.684 27.8632 9.41042 26.5896C8.13681 25.316 7.5 23.7653 7.5 21.9375C7.5 21.0625 7.66528 20.2264 7.99583 19.4292C8.32639 18.6319 8.80278 17.9222 9.425 17.3L17.3 9.425C17.9222 8.80278 18.6319 8.32639 19.4292 7.99583C20.2264 7.66528 21.0625 7.5 21.9375 7.5C23.7653 7.5 25.316 8.13681 26.5896 9.41042C27.8632 10.684 28.5 12.2347 28.5 14.0625C28.5 14.9375 28.3347 15.7736 28.0042 16.5708C27.6736 17.3681 27.1972 18.0778 26.575 18.7L18.7 26.575C18.0778 27.1972 17.3681 27.6736 16.5708 28.0042C15.7736 28.3347 14.9375 28.5 14.0625 28.5ZM21.8208 20.1583L24.9417 17.0667C25.3306 16.6778 25.6319 16.2208 25.8458 15.6958C26.0597 15.1708 26.1667 14.6264 26.1667 14.0625C26.1667 12.8958 25.7535 11.8993 24.9271 11.0729C24.1007 10.2465 23.1042 9.83333 21.9375 9.83333C21.3736 9.83333 20.8292 9.94028 20.3042 10.1542C19.7792 10.3681 19.3222 10.6694 18.9333 11.0583L15.8417 14.1792L21.8208 20.1583ZM14.0625 26.1667C14.6264 26.1667 15.1708 26.0597 15.6958 25.8458C16.2208 25.6319 16.6778 25.3306 17.0667 24.9417L20.1583 21.8208L14.1792 15.8417L11.0583 18.9333C10.6694 19.3222 10.3681 19.7792 10.1542 20.3042C9.94028 20.8292 9.83333 21.3736 9.83333 21.9375C9.83333 23.1042 10.2465 24.1007 11.0729 24.9271C11.8993 25.7535 12.8958 26.1667 14.0625 26.1667Z"
        />
      </G>
    </>
  ),
});

CapsuleIcon.displayName = "CapsuleIcon";
export { CapsuleIcon };
